module.exports = __webpack_public_path__ + "img/train_down.f314d55a.png";